import Vue from 'vue'

Vue.filter('recipe-complexity', function (value) {
  return value && value.charAt(0).toUpperCase() + value.substring(1)
})
